import Swiper from 'swiper/bundle';

$(document).ready(() => {
    if (jQuery('.img-text-slider').length) {
        const swiper = new Swiper(".img-text-slider", {
            loop: true,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
    }
});